import { GzWebsitesBlockedWebComponent } from './component/WebsitesBlockedWebComponent';

export { GzWebsitesBlockedWebComponent };
